export default __webpack_public_path__ + "media/images/404/404-gradient.png";